<template>
    <footer ref="footer">
        <div class="inner">
            <div class="left_area">
                <div class="footer_row logo">
                    <img src="@/assets/KICC_CI_en_color.svg" alt="" />
                </div>
                <div class="footer_row infor">
                    <p>
                        <span>대표이사 : 임명수</span>
                        <span class="separate"></span>
                        <span>사업자등록번호 : 116-81-19948</span>
                    </p>
                    <p>주소 : 서울 중구 세종대로 39 (남대문로 4가) 대한상공회의소 7층</p>
                </div>
                <div class="footer_row sitemenu">
                    <ul>
                        <li>
                            <router-link class="strong" to="/privacy">개인정보처리방침</router-link>
                        </li>
                        <span class="separate"></span>
                        <li>
                            <router-link to="/digital">디지털 상품권 서비스</router-link>
                        </li>
                        <span class="separate"></span>
                        <li>
                            <router-link to="/guide">이용약관</router-link>
                        </li>
                        <span class="separate"></span>
                        <li>
                            <router-link to="/company/location">오시는 길</router-link>
                        </li>
                        <span class="separate"></span>
                        <li>
                            <router-link to="/cs/voc">문의하기</router-link>
                        </li>
                    </ul>
                </div>
                <div class="footer_row copyright">
                    <p>Copyright ⓒ KICC. all rights reserved</p>
                </div>
            </div>
            <div class="right_area">
                <div class="footer_row cs">
                    <span>고객센터</span>
                    <p class="cs_number"><a href="tel:1600-1234">1600-1234</a></p>
                    <p>평일/주말 : 09:00~18:00</p>
                    <button @click="modalOpen()">
                        <span>문의별 번호 안내</span>
                        <i class="ic_outbound"></i>
                    </button>
                </div>
                <div class="footer_row sitemap" @click="foldFamilySite" ref="familySite">
                    <div>
                        <p>관련사이트</p>
                    </div>
                    <ul>
                        <li><strong>[패밀리 사이트]</strong></li>
                        <li>
                            <a href="https://www.easyshop.co.kr/" target="_blank">이지샵</a>
                        </li>
                        <li>
                            <a href="https://www.easypay.co.kr/" target="_blank">이지페이</a>
                        </li>
                        <li>
                            <a href="http://www.seoulip.com" target="_blank">서울투자파트너스</a>
                        </li>
                        <li>
                            <a href="https://easymall.kicc.co.kr" target="_blank">이지몰</a>
                        </li>
                        <li>
                            <a href="https://api.easybanking.co.kr/" target="_blank">KICC API 마켓</a>
                        </li>
                        <li>
                            <a href="https://easydatalab.co.kr" target="_blank">이지데이터랩</a>
                        </li>
                        <li>
                            <a href="https://shopinfo.kicc.co.kr" target="_blank">KICC 상권분석 서비스</a>
                        </li>
                        <li><strong>[가맹점 관리]</strong></li>
                        <li>
                            <a href="https://smart.easypos.net/index.jsp" target="_blank">포스 관리 시스템</a>
                        </li>
                        <li>
                            <a href="https://office.easypay.co.kr/" target="_blank">이지페이 가맹점 관리시스템</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
    <button v-if="showTopButton" class="top_button" @click="scrollToTop" ref="topButton">
        <img src="@/assets/ic_footer_top.png" alt="" />
    </button>
    <div class="modal_container footer_modal" v-if="modalCheck" @click.stop>
        <div class="modal_wrapper modal" @click.stop="">
            <div class="modal_header">
                <p>문의별 번호 안내</p>
                <button class="modal_close" @click="modalOpen">
                    <img src="@/assets/ic_close.png" alt="" />
                </button>
            </div>
            <div class="modal_body" data-lenis-prevent>
                <div class="modal_content">
                    <div class="content_body">
                        <section class="kicc_call_infor">
                            <p class="num">1600-1234</p>
                            <p class="infor">평일/주말 : 09:00~18:00</p>
                        </section>
                        <section class="tabel_section">
                            <table>
                                <tbody>
                                    <tr>
                                        <th colspan="2" style="text-align: center">ARS 코드</th>
                                    </tr>
                                    <tr>
                                        <th rowspan="3">
                                            <span class="tag">1번</span>
                                            가맹점
                                        </th>
                                        <td>
                                            <span class="tag">1번</span>
                                            이지체크 A/S 및 관리 대리점 전화번호 안내
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span class="tag">2번</span>
                                            현금영수증 취소
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span class="tag">3번</span>
                                            가맹점 신규 문의 상담원 연결
                                        </td>
                                    </tr>
                                    <tr>
                                        <th rowspan="4">
                                            <span class="tag">2번</span>
                                            가맹점
                                        </th>
                                        <td>
                                            <span class="tag">1번</span>
                                            이지체크단말기 번호 확인조회
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span class="tag">2번</span>
                                            가맹점 번호조회
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span class="tag">3번</span>
                                            단말기 다운로드 허용여부 변경
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span class="tag">0번</span>
                                            단말기 A/S문의 상담원 연결
                                        </td>
                                    </tr>
                                    <tr>
                                        <th rowspan="2">
                                            <span class="tag">3번</span>
                                            가맹점
                                        </th>
                                        <td>
                                            <span class="tag">1번</span>
                                            카드 매출관리 이용문의 상담원연결
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span class="tag">2번</span>
                                            자동장부 및 세금신고 문의
                                        </td>
                                    </tr>
                                    <tr>
                                        <th rowspan="5">
                                            <span class="tag">4번</span>
                                            전자상거래문의
                                        </th>
                                        <td>
                                            <span class="tag">1번</span>
                                            인터넷결제 사용처 조회
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span class="tag">2번</span>
                                            결제창 설치 관련 문의
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span class="tag">3번</span>
                                            계약 관련 문의
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span class="tag">4번</span>
                                            정산 및 세금 계산서 문의
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span class="tag">0번</span>
                                            기타 문의 상담원 연결
                                        </td>
                                    </tr>
                                    <tr>
                                        <th rowspan="8">
                                            <span class="tag">5번</span>
                                            전자상거래문의
                                        </th>
                                        <td>
                                            <span class="tag">1번</span>
                                            인사담당
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span class="tag">2번</span>
                                            법인팀
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span class="tag">3번</span>
                                            대리점팀
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span class="tag">4번</span>
                                            정유담당
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span class="tag">5번</span>
                                            기술연구소
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span class="tag">6번</span>
                                            DATA CENTER
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span class="tag">7번</span>
                                            포인트 서비스 담당
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span class="tag">8번</span>
                                            카드 사업 담당
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <span class="tag">6번</span>
                                            카드사 전화번호 안내
                                        </th>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <span class="tag">7번</span>
                                            단말기 이용방법 안내
                                        </th>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <span class="tag">8번</span>
                                            회사 위치 안내
                                        </th>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <span class="tag">9번</span>
                                            부가세 참조안내
                                        </th>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <span class="tag">0번</span>
                                            상담원 연결
                                        </th>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            showTopButton: true,
            footerOffsetTop: 0,
            modalCheck: false,
        };
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
        document.addEventListener('click', this.handleOutsideClick);

        this.$nextTick(() => {
            this.handleScroll();
        });
    },
    unmounted() {
        window.removeEventListener('scroll', this.handleScroll);
        document.removeEventListener('click', this.handleOutsideClick);
    },
    methods: {
        modalOpen() {
            this.modalCheck = !this.modalCheck;
            if (this.modalCheck) this.$lenis.stop();
            else this.$lenis.start();
        },
        foldFamilySite() {
            this.$refs.familySite.classList.toggle('open');
        },

        handleScroll() {
            this.footerOffsetTop = this.$refs.footer.offsetTop;
            this.showTopButton = window.scrollY > 0;

            if (this.showTopButton) {
                const bottomOffset =
                    window.scrollY + window.innerHeight > this.footerOffsetTop
                        ? `${window.scrollY + window.innerHeight - this.footerOffsetTop + 20}px`
                        : '20px';

                if (this.$refs.topButton) this.$refs.topButton.style.bottom = bottomOffset;
            }
        },
        scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        },
        handleOutsideClick(event) {
            // 사이트맵이 열려있고, 클릭된 요소가 사이트맵 영역 내부가 아닌 경우 닫기
            if (this.$refs.familySite && this.$refs.familySite.classList.contains('open')) {
                if (!this.$refs.familySite.contains(event.target)) {
                    this.$refs.familySite.classList.remove('open');
                }
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.top_button {
    cursor: pointer;
    width: 60px;
    height: 60px;
    border: 1px solid #dedede;
    background: var(--white);
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 100;

    @media screen and (max-width: 768px) {
        width: 36px;
        height: 36px;

        img {
            max-width: 30%;
        }
    }
}

footer {
    width: 100%;
    max-width: 100%;
    border-top: 1px solid var(--border-color4);

    .inner {
        width: 100%;
        max-width: 1920px;
        padding: 80px 110px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;

        .left_area {
            .footer_row {
                &.logo {
                    margin-bottom: 36px;
                    max-width: 162px;

                    @media screen and (max-width: 768px) {
                        max-width: 110px;
                        margin-bottom: 20px;
                    }
                }

                &.infor {
                    font-family: 'Pretendard', sans-serif;
                    font-size: 16px;
                    font-weight: 500;
                    color: var(--black4);
                    letter-spacing: -0.025em;
                    display: flex;
                    flex-direction: column;
                    gap: 15px;
                    margin-bottom: 60px;

                    p {
                        display: flex;
                        align-items: center;
                    }
                }

                &.sitemenu {
                    margin-bottom: 30px;

                    @media screen and (max-width: 768px){
                        margin-bottom: 20px;
                    }

                    ul {
                        display: flex;
                        align-items: center;
                        gap: 5px 0;

                        @media screen and (max-width: 768px) {
                            flex-wrap: wrap;
                            flex-direction: column;
                            align-items: flex-start;
                            gap: 0;
                        }

                        li {
                            list-style: none;

                            a {
                                font-family: 'Pretendard', sans-serif;
                                font-size: 16px;
                                font-weight: 500;
                                color: var(--black4);
                                letter-spacing: -0.025em;

                                @media screen and (max-width: 768px) {
                                    white-space: nowrap;
                                }

                                &.strong {
                                    font-weight: 700;
                                    color: var(--black1);
                                }
                            }
                        }
                    }
                }

                &.copyright p {
                    font-family: 'Pretendard', sans-serif;
                    font-size: 16px;
                    font-weight: 500;
                    color: var(--black4);
                    letter-spacing: -0.025em;
                }

                .separate {
                    margin: 0 12px;
                    width: 1px;
                    height: 12px;
                    background: var(--gray1);

                    @media screen and (max-width: 768px) {
                        margin: 0 8px;
                        background: transparent;
                    }
                }
            }
        }

        .right_area {
            display: flex;
            flex-direction: column;
            align-items: flex-end;

            .footer_row {
                &.cs {
                    font-family: 'Pretendard', sans-serif;
                    font-size: 16px;
                    font-weight: 500;
                    color: var(--black4);
                    letter-spacing: -0.025em;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-end;

                    @media screen and (max-width: 768px) {
                        font-size: 13px;
                        align-items: flex-start;
                    }

                    span {
                        display: block;
                    }

                    .cs_number {
                        font-family: 'Poppins', sans-serif;
                        font-size: 36px;
                        font-weight: 600;
                        color: var(--black1);
                        letter-spacing: -0.025em;
                        line-height: 1;
                        margin-top: 10px;
                        margin-bottom: 20px;
                    }

                    button {
                        cursor: pointer;
                        display: flex;
                        justify-content: flex-start;
                        align-items: center;
                        margin-top: 30px;
                        gap: 10px;

                        font-family: 'Pretendard', sans-serif;
                        font-size: 16px;
                        font-weight: 500;
                        color: var(--black4);
                        letter-spacing: -0.025em;
                        opacity: 0.8;

                        @media screen and (max-width: 768px) {
                            margin-top: 20px;
                        }

                        .ic_outbound {
                            display: inline-block;
                            width: 14px;
                            height: 14px;
                            background-image: url('@/assets/ic_outbound2.png');
                            background-repeat: no-repeat;
                            background-position: center;
                            background-size: contain;
                        }

                        &:hover {
                            opacity: 1;
                        }
                    }
                }

                &.sitemap {
                    cursor: pointer;
                    position: relative;
                    margin-top: auto;
                    font-family: 'Pretendard', sans-serif;
                    font-size: 15px;
                    font-weight: 600;
                    color: var(--black2);
                    letter-spacing: -0.025em;

                    border: 1px solid var(--border-color4);

                    width: 260px;
                    height: 60px;

                    display: flex;
                    align-items: center;
                    padding: 0 20px;

                    background: url('@/assets/ic_arrow_up-black.png') no-repeat calc(100% - 20px) center / 15px 9px;

                    @media screen and (max-width: 768px) {
                        width: 80%;
                        height: 42px;
                        p {
                          font-size: 14px;
                        }
                    }

                    ul {
                        display: none;
                    }

                    &.open {
                        ul {
                            cursor: default;
                            background: #fff;
                            display: block;
                            position: absolute;
                            width: calc(100% + 2px);
                            bottom: 100%;
                            left: -1px;
                            border: 1px solid var(--border-color4);
                            border-bottom: none;
                            padding: 10px 0;

                            li {
                                list-style: none;
                                background: #fff;
                                font-weight: 400;

                                strong {
                                    display: block;
                                    padding: 10px 20px;
                                    color: var(--black1);
                                    font-weight: 600;
                                }

                                a {
                                    cursor: pointer;
                                    padding: 10px 20px;
                                    display: block;

                                    &:hover {
                                        color: var(--red);
                                    }
                                }

                                &:has(a) {
                                    padding-left: 5px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

@media screen and (max-width: 1600px) {
    footer {
        .inner {
            max-width: 90%;
            padding: 80px 0;
        }
    }
}

@media screen and (max-width: 1024px) {
    footer {
        .inner {
            flex-direction: column;

            .left_area .footer_row {
                &.infor {
                    font-size: 13px;
                    margin-bottom: 20px;
                    gap: 10px;
                }

                &.copyright p {
                    font-size: 13px;
                }

                &.sitemenu {                    
                    ul li a {
                        font-size: 12px;
                    }
                }
            }

            .right_area {
                margin-top: 60px;
                flex-direction: row;
                justify-content: space-between;
                flex-wrap: wrap;
                gap: 30px;

                @media screen and (max-width: 768px) {
                    gap: 30px;
                    flex-direction: column;
                    align-items: flex-start;
                    margin-top: 20px;
                }

                .footer_row {
                    &.cs {
                        .cs_number {
                            font-size: 24px;

                            @media screen and (max-width: 768px) {
                                font-size: 22px;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
